import {
  setDoc,
  doc,
  onSnapshot,
  collection,
  getDocs,
  deleteDoc,
  Timestamp,
} from 'firebase/firestore'
import { db } from './firebase'
import { v4 as uuidv4 } from 'uuid'

import { authentication } from '.'
import * as storageKeys from '~/constants/localStorage' // skipcq JS-C1003

export type Device = {
  deviceID: string
  userAgent: string
  timestamp: Timestamp | string
}

export const getDeviceId = () => {
  let deviceID = window.localStorage.getItem(storageKeys.DEVICE_ID)

  if (!deviceID) {
    deviceID = uuidv4()
    window.localStorage.setItem(storageKeys.DEVICE_ID, deviceID)
  }

  return deviceID
}

const getCurrentUserId = async () => {
  const authUser = await authentication.loadCurrentUser()
  return authUser.id
}

const getCurrentDeviceSessionRef = (userId: string) => {
  const deviceID = getDeviceId()
  return doc(db, 'loginsv2', userId, 'devices', deviceID)
}

export const upsertCurrentDeviceSession = async () => {
  const userId = await getCurrentUserId()
  if (!userId) return

  const timestamp = Timestamp.fromMillis(Date.now())
  const device = {
    deviceID: getDeviceId(),
    userAgent: navigator.userAgent,
    timestamp,
  }

  try {
    await setDoc(getCurrentDeviceSessionRef(userId), device)
  } catch (e) {
    console.error('Error adding document: ', e)
  }
}

export const trackLogout = async () => {
  const userId = await getCurrentUserId()
  if (!userId) return

  try {
    await deleteDoc(getCurrentDeviceSessionRef(userId))
  } catch (e) {
    console.error('Error removing device: ', e)
  }
}

export const getCurrentDevices = async () => {
  const userId = await getCurrentUserId()
  if (!userId) return []

  try {
    const querySnapshot = await getDocs(
      collection(db, 'loginsv2', userId, 'devices'),
    )
    return querySnapshot.docs.map(doc => doc.data() as Device)
  } catch (error) {
    console.error('Error getting current devices: ', error)
    return []
  }
}

export const subscribeToDeviceChanges = async (
  callback: (data: Device[]) => void,
) => {
  const userId = await getCurrentUserId()
  if (!userId) return null

  return onSnapshot(
    collection(db, 'loginsv2', userId, 'devices'),
    { includeMetadataChanges: true },
    querySnapshot => {
      callback(querySnapshot.docs.map(doc => doc.data() as Device))
    },
  )
}
